import { jsx as e } from "react/jsx-runtime";
const t = (o) => /* @__PURE__ */ e("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", "aria-hidden": !0, focusable: !1, ...o, children: /* @__PURE__ */ e("path", { d: "M2 14.1333L16 2.93335L30 14.1333M13.2 29.0667V21.6H18.8V29.0667M5.73333 16V29.0667H26.2667V16M7.59961 9.65338V4.80005M14.1338 13.2001H17.8671V16.9334H14.1338V13.2001Z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }) });
export {
  t as default
};
//# sourceMappingURL=housing.js.map
